export const getBrowserLanguage = (): string => {
    return (
        navigator.language.slice(0, 2) ||
        navigator.languages[0].slice(0, 2) ||
        "en"
    );
};

export const getAppLanguage = (): string => {
    if (window.Weglot) return window.Weglot.getCurrentLang();
    return "en";
};

export const hideLanguageSwitcher = (): void => {
    const weglotSwitcher = document.querySelector(
        ".weglot_switcher"
    ) as HTMLElement;
    if (weglotSwitcher) {
        weglotSwitcher.style.display = "none";
    }
};

export const showLanguageSwitcher = (): void => {
    const weglotSwitcher = document.querySelector(
        ".weglot_switcher"
    ) as HTMLElement;
    if (weglotSwitcher) {
        weglotSwitcher.style.display = "";
    }
};
